import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { isEmail, isValidPhone } from '../../utils/validation';
import { ViewContainer } from '../ViewContainer';
import { PhoneField } from '../../components/PhoneField';
import { InputField } from '../../components/InputField';
import { EActiveView } from '../../types/view';
import { EKeyCode } from '../../types/keyCodes';
import { ContentLayout } from '../../components/ContentLayout';
import { TitleContainer } from '../TitleContainer';
import { trackLoginNeedHelp, trackSocialCreateShow } from '../../utils/tracking';
import { FormFieldGroupLayout } from '../../components/FieldGroupLayout';
import { HelpContainer } from '../HelpContainer';
export function SocialCreateViewContainer(_ref) {
  var disabled = _ref.disabled,
    hasError = _ref.hasError,
    error = _ref.error,
    phone = _ref.phone,
    email = _ref.email,
    reset = _ref.reset,
    create = _ref.create,
    changeView = _ref.changeView,
    changeEmail = _ref.changeEmail,
    changePhone = _ref.changePhone;
  // FORM
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    changed = _React$useState2[0],
    setChanged = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    touched = _React$useState4[0],
    setTouched = _React$useState4[1];

  // EMAIL
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isEmailInvalid = _React$useState6[0],
    setEmailInvalid = _React$useState6[1];

  // PHONE
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isPhoneInvalid = _React$useState8[0],
    setPhoneInvalid = _React$useState8[1];
  var handleEmailChange = React.useCallback(function (e) {
    var value = e.currentTarget.value;
    setEmailInvalid(value === '' || value !== '' && !isEmail(value));
    setChanged(true);
    changeEmail(value);
  }, [changeEmail]);
  var handlePhoneChange = React.useCallback(function (value) {
    changePhone(value);
    setChanged(true);
    setPhoneInvalid(value === '' || value !== '' && !isValidPhone(value));
  }, [changePhone]);
  var handleSubmit = React.useCallback(function () {
    setTouched(true);
    if (disabled || isEmailInvalid || isPhoneInvalid) {
      return;
    }
    create();
    setChanged(false);
  }, [disabled, isEmailInvalid, isPhoneInvalid, create]);
  var handleCancel = React.useCallback(function () {
    reset();
    changeView(EActiveView.AuthenticationRegistration);
  }, [changeView, reset]);
  React.useEffect(function () {
    trackSocialCreateShow();
  }, []);
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/React.createElement(ViewContainer, null, /*#__PURE__*/React.createElement(TitleContainer, null), /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputField, {
      "data-name": "EmailInput",
      autoFocus: true,
      id: "social_create-email",
      name: "email",
      placeholder: "Email",
      invalid: touched && (hasError && !changed || isEmailInvalid),
      errorMessage: !changed && hasError ? error : undefined,
      value: email,
      onChange: handleEmailChange,
      onKeyDown: handleSubmitOnEnter,
      disabled: disabled
    }), /*#__PURE__*/React.createElement(PhoneField, {
      id: "social_create-phone",
      name: "phone",
      placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      invalid: touched && (hasError && !changed || isPhoneInvalid),
      value: phone,
      onValueChange: handlePhoneChange,
      onKeyDown: handleSubmitOnEnter,
      disabled: disabled
    })),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      "data-name": "SubmitSocialCreate",
      theme: "fill_primary",
      fullWidth: true,
      disabled: !email,
      loading: disabled,
      onClick: handleSubmit
    }, "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F"), /*#__PURE__*/React.createElement(Button, {
      "data-name": "CancelSocialCreate",
      theme: "fill_secondary",
      fullWidth: true,
      onClick: handleCancel
    }, "\u041E\u0442\u043C\u0435\u043D\u0430"))
  }))), /*#__PURE__*/React.createElement(HelpContainer, {
    onClick: trackLoginNeedHelp
  }));
}